export default "__VITE_ASSET__L9K_PujO__"